<!--
 * @Description: 编辑工资条
 * @Author: fely
 * @Date: 2020-06-12 14:50:53
 * @LastEditTime: 2020-09-14 16:22:37
 * @LastEditors: fely
--> 
<template>
  <div class="update-slip">
    <div class="top-menu">
      <span>编辑工资条</span>
      <span class="el-icon-close close" @click="closeMask"></span>
    </div>
   
    <div class="form-box">
      <div v-for="(item, index) in list" :key="index" class="wrapper">
        <p>{{item.label}}</p>
        <input type="text" v-model="item.value">
      </div>
      
    </div>
    <div class="btn-box">
      <div class="check-box">
        <el-checkbox v-model="checked">确定后立即重新发送</el-checkbox>
      </div>
      <div class="btns">
        <div class="cancle" @click="closeMask">取消</div>
        <div class="confirm" @click="submitForm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import {updatePersonSlip} from 'api/slip'
export default {
  name: '',
  components: {},
  data() {
    return {
      checked: true,
    }
  },
  props: {
    slipObj: {
      type: String,
      default(){
        return ''
      }
    },
    payperid: {
      type: String,
      default: ''
    },
    paycomid: {
      type: String,
      default: ''
    },
    hiddenItem: {
      type: String,
      default(){
        return ''
      }
    }
  },
  computed: {
    list(){
      if(this.slipObj){
        
        let arr = [], tempObj = {}
        let obj = this.slipObj.split('],[')
        let tempTitle = obj[0].substring(1,obj[0].length).split(',')
        let tempValue = obj[1].substring(0,obj[1].length-2).split(',')
        let arr2 = []   //隐藏项
        if(this.hiddenItem.indexOf(',')>=0){
          arr2 = this.hiddenItem.split(',')
        }else if(this.hiddenItem!=''){
          arr2.push(this.hiddenItem)
        }
        for (const key in tempTitle) {
          tempObj = {}
          tempObj.label = tempTitle[key]
          if(tempValue[key] !=" null")  tempObj.value = tempValue[key]
          else tempObj.value = ""
          if(tempTitle[key] != " null"){
            let tempflag = false
            tempflag = arr2.some(function(item){
              return item == tempTitle[key].trim()
            })
            if(!tempflag) arr.push(tempObj)
            
          }
        }
        return arr
      }else{
        return []
      }
    },
  },
  
  methods: {
    closeMask(){
      this.$emit('closeMask')
    },
    submitForm(){
      let titleStr = ''
      let valueStr = ''
      this.list.forEach((element,index) => {
        if(index == this.list.length-1){
          titleStr += element.label
          valueStr += element.value
        }else{
          titleStr += element.label + ','
          valueStr += element.value + ','
        }
        
      })
      updatePersonSlip(this.paycomid,this.payperid,"["+titleStr+"],["+valueStr+"]",this.checked).then( (res) => {
        if(res.code == 200){
          this.$emit('closeMask',1)
        }else{
          this.$message.error(res.msg)
          this.$emit('closeMask',res.msg)
        }
        
      })
    }
  },
}
</script>

<style scoped lang="less">
.update-slip{
  background-color: #fff;
  width: 320px;
  height: 426px;
  display: flex;
  flex-direction: column;
  .top-menu{
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px 12px 14px;
    cursor: pointer;
  }
  .btn-box{
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
    padding-right: 13px;
    box-sizing: border-box;
    .check-box{
      color: #4E90FF;
      font-size: 10px;
      line-height: 14px;
    }
    .btns{
      display: flex;
      div{
        width: 55px;
        height: 25px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(220,223,230,1);
        opacity:1;
        border-radius:2px;
        font-size: 8px;
        color: #333;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .confirm{
        margin-left: 10px;
        background: #4962FE;
        color: #fff;
      }
    }
  }
}
.form-box{
  height: 80%;
  display: flex;
  flex-direction: column;
  padding:20px 14px 0 14px;
  margin-left: 28px;
  margin-right: 13px;
  font-size: 10px;
  overflow-y: scroll;
  div.wrapper{
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    p{
      text-align: left;
      color: #99A9BF;
      line-height: 24px;
      height: 24px;
    }
    input{
        width: 100px;
        height: 22px;
        color: #333;
        line-height: 14px;
        border: 1px solid #DCDFE6;
        padding-left: 10px;
      }
  }
}
.close{
  display: inline-block;
  cursor: pointer;
}
</style>
